export default {
    heading: 'Manage License Status',

    filters: {
        status_placeholder: 'Filter by status',
    },

    table: {
        user: 'User',
        npi_number: 'NPI Number',
        license_file: 'License File',
        status: 'Status',
        uploaded_date: 'Uploaded Date',
        actions: 'Actions',
        view_file: 'View File',
        approve: 'Approve',
        reject: 'Reject',
        no_requests: 'No license requests found',
    },

    pagination: {
        info: 'Page {current} of {total}',
    },

    modal: {
        title: 'License File',
    },

    notifications: {
        load_failed: 'Failed to load license requests',
        approve_success: 'License approved successfully',
        approve_failed: 'Failed to approve license',
        reject_success: 'License rejected successfully',
        reject_failed: 'Failed to reject license',
        file_not_found: 'License file not found in storage. The file may have been deleted or moved.',
        load_file_failed: 'Failed to load license file',
    },
}
